import { Person, ShoppingBag } from "@mui/icons-material";
import { Avatar, Grid, Stack, SxProps, Theme, Typography } from "@mui/material";
import { ReactNode } from "react";

interface IconTextProps {
  iconSrc: string | null;
  topText: string;
  bottomText: string | ReactNode;
  variant?: "rounded" | "square" | "circular";
  sxIcon?: SxProps<Theme>;
  is4Item?: boolean;
  error?: boolean;
  warning?: boolean;
  success?: boolean;
  svg?: ReactNode;
  onPrimaryBg?: boolean;
  topTextSx?: any;
  bottomTextSx?: any;
}

const IconText: React.FC<IconTextProps> = ({
  topTextSx,
  bottomTextSx,
  iconSrc,
  topText,
  bottomText,
  variant,
  sxIcon,
  is4Item,
  error,
  warning,
  success,
  svg,
  onPrimaryBg,
}) => {
  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item>
        <Stack direction="row" spacing={1.25} alignItems="center">
          {!svg && (
            <Avatar
              alt="profile user"
              src={
                iconSrc
                  ? `${process.env.REACT_APP_SERVER_ENDPOINT}/${iconSrc}`
                  : ""
              }
              sx={
                sxIcon
                  ? sxIcon
                  : {
                      "& img": {
                        width: "100% !important",
                        height: "100% !important",
                        objectFit: "cover !important",
                      },
                      width: 32,
                      height: 32,
                      bgcolor: error
                        ? "red"
                        : warning
                        ? "rgb(250, 173, 20)"
                        : success
                        ? "rgb(82, 196, 26);"
                        : "secondary",
                    }
              }
              variant={variant ? variant : "circular"}
            >
              {is4Item && (
                <ShoppingBag style={{ height: "60%", width: "60%" }} />
              )}
              {!is4Item && <Person style={{ height: "60%", width: "60%" }} />}
            </Avatar>
          )}
          {svg && (
            <Avatar
              alt="profile user"
              src={
                iconSrc
                  ? `${process.env.REACT_APP_SERVER_ENDPOINT}/${iconSrc}`
                  : ""
              }
              sx={
                sxIcon
                  ? sxIcon
                  : {
                      "& img": {
                        width: "100% !important",
                        height: "100% !important",
                        objectFit: "cover !important",
                      },
                      width: 32,
                      height: 32,
                      bgcolor: error
                        ? "red"
                        : warning
                        ? "rgb(250, 173, 20)"
                        : success
                        ? "rgb(82, 196, 26);"
                        : "secondary",
                    }
              }
              variant={variant ? variant : "circular"}
            >
              {svg}
            </Avatar>
          )}
          <Stack>
            <Typography
              variant="h6"
              sx={
                topTextSx ??
                (onPrimaryBg
                  ? {
                      fontSize: "1rem !important",
                      fontWeight: "400 !important",
                    }
                  : {})
              }
              color={
                error
                  ? "red"
                  : warning
                  ? "rgb(250, 173, 20)"
                  : success
                  ? "rgb(82, 196, 26);"
                  : onPrimaryBg
                  ? "white !important"
                  : "black !important"
              }
            >
              {topText}
            </Typography>
            <Typography
              variant="body2"
              sx={
                bottomTextSx ??
                (onPrimaryBg
                  ? {
                      fontStyle: "italic",
                      fontSize: ".75rem !important",
                      fontWeight: "400 !important",
                    }
                  : {})
              }
              color={
                error
                  ? "error"
                  : onPrimaryBg
                  ? "white !important"
                  : "textSecondary !important"
              }
            >
              {bottomText}
            </Typography>
          </Stack>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default IconText;
